import { render, staticRenderFns } from "./userDashboardCustomerTraining.vue?vue&type=template&id=7823b92e"
import script from "./userDashboardCustomerTraining.vue?vue&type=script&lang=js"
export * from "./userDashboardCustomerTraining.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports